// extracted by mini-css-extract-plugin
export default {"container":"SgI0_","content":"yrDNY","additionalInfo":"IGoor","divider":"AshgE","widgetContent":"viqOx","spinner":"FewEs","item":"M67NE"};